<template>
  <transition name="delete-account-modal-fade">
    <div v-if="show" class="delete-account-modal-overlay" @click.self="handleCancel">
      <div class="delete-account-modal" @click.stop>
        <div class="delete-account-modal-header">
          <button class="delete-account-modal-close" @click="handleCancel" :disabled="loading">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        
        <div class="delete-account-icon-wrapper">
          <div class="delete-account-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <!-- Outer warning circle -->
              <circle 
                cx="12" 
                cy="12" 
                r="10" 
                stroke="currentColor" 
                stroke-width="2.5" 
                class="delete-account-circle"
                fill="none"
              />
              <!-- Warning triangle -->
              <path 
                d="M12 8V12M12 16H12.01" 
                stroke="currentColor" 
                stroke-width="2.5" 
                stroke-linecap="round" 
                class="delete-account-warning"
              />
              <!-- Animated pulse rings -->
              <circle 
                cx="12" 
                cy="12" 
                r="10" 
                class="delete-account-pulse-ring delete-account-pulse-1"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                opacity="0.3"
              />
              <circle 
                cx="12" 
                cy="12" 
                r="10" 
                class="delete-account-pulse-ring delete-account-pulse-2"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                opacity="0.2"
              />
            </svg>
          </div>
        </div>

        <div class="delete-account-modal-body">
          <h3 class="delete-account-title">Delete Your Account?</h3>
          <p class="delete-account-message">
            This action cannot be undone. All your data, companies, and information will be permanently deleted.
          </p>
          
          <div class="delete-account-warning-box">
            <div class="delete-account-warning-item">
              <i class="bi bi-exclamation-triangle-fill"></i>
              <span>All your companies will be deleted</span>
            </div>
            <div class="delete-account-warning-item">
              <i class="bi bi-exclamation-triangle-fill"></i>
              <span>All your financial data will be lost</span>
            </div>
            <div class="delete-account-warning-item">
              <i class="bi bi-exclamation-triangle-fill"></i>
              <span>This action is permanent and irreversible</span>
            </div>
          </div>

          <div class="delete-account-confirmation">
            <label class="delete-account-checkbox-label">
              <input 
                type="checkbox" 
                v-model="confirmed" 
                :disabled="loading"
                class="delete-account-checkbox"
              />
              <span>I understand that this action cannot be undone</span>
            </label>
          </div>
        </div>

        <div class="delete-account-modal-footer">
          <button 
            class="delete-account-btn delete-account-btn-cancel" 
            @click="handleCancel"
            :disabled="loading"
          >
            Cancel
          </button>
          <button 
            class="delete-account-btn delete-account-btn-confirm" 
            @click="handleConfirm"
            :disabled="!confirmed || loading"
          >
            <span v-if="loading" class="delete-account-spinner">
              <svg class="delete-account-spinner-svg" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" class="delete-account-spinner-circle"/>
              </svg>
            </span>
            <span v-else>Delete Account</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import './DeleteAccountModal.css';

export default {
  name: 'DeleteAccountModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['confirm', 'cancel'],
  data() {
    return {
      confirmed: false
    }
  },
  watch: {
    show(newVal) {
      if (!newVal) {
        // Reset confirmation when modal closes
        this.confirmed = false;
      }
    }
  },
  methods: {
    handleConfirm() {
      if (this.confirmed && !this.loading) {
        this.$emit('confirm');
      }
    },
    handleCancel() {
      if (!this.loading) {
        this.$emit('cancel');
      }
    }
  }
}
</script>
